import InfoIcon from "src/assets/icons/SsqTitleIcon/info.svg?react";

import { Page1 } from "./Pages/Page1";
import { Page2 } from "./Pages/Page2";
import { FoodsFormBase, FoodsPage } from "@foodpilot/foods";

import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCreatePackaging } from "src/api/client-api/packagings/useCreatePackaging";
import FormIcon from "src/assets/icons/SsqTitleIcon/form.svg?react";
import { PackagingService } from "../PackagingService";
import { Packaging } from "src/api/client-api/packagings/useGetOnePackaging";
import { useState } from "react";
import { PackagingFormType } from "./PackagingForm.types";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { URLHandler } from "src/services/URLHandler";

type PackagingFormProps = {
    existingPackaging?: Packaging;
    startingPageId: string;
};
export const PackagingForm = (props: PackagingFormProps) => {
    const { selectedCompany } = useFoodpilotContext();
    const { existingPackaging, startingPageId } = props;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const createPackaging = useCreatePackaging();

    const formData = PackagingService.getPackagingToCreate(existingPackaging);
    const [packaging, setPackaging] = useState<PackagingFormType>(formData);

    const allPages: FoodsPage[] = [
        {
            title: t("general_information"),
            icon: <InfoIcon />,
            content: <Page1 packaging={packaging} setPackaging={setPackaging} />,
        },
        {
            title: t("Résumé des données renseignées"),
            icon: <FormIcon />,
            content: <Page2 packaging={packaging} />,
        },
    ];

    const isNew = existingPackaging === undefined;

    // pageId can be an invalid string.
    // If the string is invalid, result is NaN
    // It is not shown in the types.
    const pageId = Number.parseInt(startingPageId);

    if (isNaN(pageId) || selectedCompany === null) {
        return <Typography variant="big-bold">The page you are trying to access does not exist.</Typography>;
    }

    const companyIri = selectedCompany["@id"];

    return (
        <Box component="div" sx={{ marginLeft: "auto", marginRight: "auto", padding: "40px 52px " }}>
            <FoodsFormBase
                showSync={false}
                startingPage={pageId}
                onClose={() => navigate(URLHandler.packaging.list(selectedCompany.id))}
                textOptions={{
                    title: isNew ? t("packagings.creation") : t("packagings.modification"),
                    subtitle:
                        packaging.externalId ?
                            `${packaging.name || ""} - ${packaging.externalId}`
                        :   `${packaging.name || ""}`,
                    nextPage: t("Etape suivante"),
                    previousPage: t("previous"),
                    finalPage: t("Sauvegarder"),
                }}
                pages={allPages}
                onValidate={() => {
                    const options = {
                        packaging:
                            isNew ?
                                PackagingService.packagingFormToPackagingWrite(packaging, companyIri)
                            :   PackagingService.packagingFormToPackagingWrite(packaging),
                    };
                    return createPackaging.mutate(options, {
                        onSuccess: () => {
                            navigate(URLHandler.packaging.list(selectedCompany.id));
                        },
                    });
                }}
                confirmExit={true}
                confirmOptions={{
                    titleText:
                        isNew ?
                            t("packagings.creation.quit.confirmation")
                        :   t("packagings.modification.quit.confirmation"),
                    confirmText: isNew ? t("Supprimer et quitter") : t("Ne pas enregistrer et quitter"),
                    cancelText: isNew ? t("Ne pas quitter la création") : t("Ne pas quitter la modification"),
                    onConfirm: () => navigate(URLHandler.packaging.list(selectedCompany.id)),
                    onCancel: () => {
                        // Do nothing;
                    },
                }}
            />
        </Box>
    );
};
